<template>
              <div class="container container--narrow d-flex justify-content-center flex-column pdb-50 mgt-100">
                <div class=" t-center">
                    <img src="/images/helpdesk/notice-nodata.svg" alt="" class="no-degree-image mgx-auto">
                </div>
                <div class="mgt-24 t-center t-headline8 font-r">
                   {{ $t("1369") }}
                </div>
                <div class="mgt-4 t-center t-body1 t-color-bodyGrayA">{{ $t("1370") }}</div>

            </div>
            
</template>

<script>
/**
 * 데이터 없음 컴포넌트(no data Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {};
</script>
<style scoped>

.no-data-image {
  width: 123px;
  height: 143px;
}
</style>
